import React from 'react'
import { Box } from "@mui/material"

import { AppRetailerBlock } from "@components/DataBlocks/index"
import { AppButtonIcon } from "@components/@base"
import { sitesModalData } from "@signals"


export default function AppRetailerBlockContainer({ rows }) {
	return <Box sx={{ display: "flex", alignItems: "start", justifyContent: "start", flexDirection: "column" }}>
		{rows?.map(({ name, market }, idx) => {
			if (idx < 10) {
				return <AppRetailerBlock
					key={idx}
					retailer={name}
					country={market}
				/>
			}
		})}
		{rows?.length > 10 && <AppButtonIcon
			onClick={() => sitesModalData.value = rows}
			iconWeight="regular"
			icon="plus"
			tooltip={`Show all`}
			sx={{ color: "info.main", pl: .2 }}
		/>}
	</Box>
}